module.exports = __webpack_public_path__ + "img/to-do-list.c2147609.svg";